// extracted by mini-css-extract-plugin
export default {"logoSign":"Footer_logoSign__xY56n"};